import type { PropsWithChildren } from 'react'

import clsx from 'clsx'
import { SupportButton } from 'components/atoms/SupportButton/SupportButton.js'

// Style
import './style.scss'

import { NotificationUI } from 'features/notifications'

// configs
import { CONSTS } from '../../../config/objectConst.js'
import Logo from '../../atoms/Logo/index.js'
// Components
import css from './AuthTemplate.module.scss'

const STEPS = [1, 2, 3, 4, 5]
const YEAR = new Date().getFullYear()

import { typo } from 'shared/styles'

AuthTemplate.cn = {
	action: css.action,
	image: css.image,
	text: clsx(typo.mediumBody, css.text),
	title: clsx(typo.subtitle, css.title)
}

export function AuthTemplate({
	active,
	children,
	className,
	show = STEPS.length
}: PropsWithChildren & {
	active: number
	className?: string
	show?: number
}) {
	const steps = STEPS.slice(0, show)

	return (
		<div className={clsx(css.root, className)}>
			<NotificationUI.Notification />
			<Logo />
			<div className={`${css.body} template-wrapper-auth__body`}>
				<div className={css.box}>{children}</div>
				<div className={css.steps}>
					{steps.map((item, index) => (
						<div
							className={clsx(css.step, item === active && css.active)}
							key={index}
						/>
					))}
				</div>
			</div>
			<footer className={css.footer}>
				<a
					className={css.footerText}
					href={CONSTS.TERMS_AND_CONDITIONS_URL}
					rel='noopener noreferrer'
					target='_blank'
				>
					Terms and Conditions
				</a>

				<small className={css.footerText}>
					{`© ${CONSTS.PROJECT_NAME}  ${YEAR}`}
				</small>
			</footer>
			<SupportButton />
		</div>
	)
}
